import moment from "moment"
import React from "react"
import Row from "../Row"
import { IInfoDetailsProduct } from "./interface"
import { FirstCol, Info, Legend, SecondCol, Space, ThirdCol } from "./style"

const InfoDetailsProduct = ({
    listDetails
}: IInfoDetailsProduct
): React.ReactElement => {

    return (
        <>
            {
                listDetails.map((product: any) => {
                    return (
                            <Row>
                                <FirstCol>
                                    <Legend>Detalhe</Legend>
                                    <Info>{ product.details }</Info>
                                </FirstCol>
                                <SecondCol>
                                    <Legend>Status</Legend>
                                    <Info>{ product.active === null ? "Inativo" : "Ativo" }</Info>
                                </SecondCol>
                                { product.amount !== null ?
                                    <ThirdCol>
                                        <Legend>Valor</Legend>
                                        <Info>R$ {(product.amount / 100).toLocaleString("pt-br", {minimumFractionDigits: 2, maximumFractionDigits: 2})}</Info>
                                    </ThirdCol>
                                    : <ThirdCol>
                                        <Legend>Data da criação</Legend>
                                        <Info>{moment(product.created_at).format("DD/MM/YYYY hh:mm")}</Info>
                                    </ThirdCol>
                                }
                                <Space/>
                            </Row>
                    )
                })
            }
        </>
    )
}

export default InfoDetailsProduct